import { gallery } from "@/data/gallery";
import { Badge } from "@/components/ui/badge";

const toneVariant = (tone: string) =>
  tone === "light" ? "secondary" : tone === "dark" ? "default" : "outline";

const GalleryPreview = () => {
  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-7xl">
        <header className="mb-6">
          <h1 className="text-2xl font-semibold text-foreground">Gallery preview</h1>
          <p className="text-sm text-muted-foreground">
            {gallery.length} images — sanity check ordering, tone alternation, and quality.
          </p>
        </header>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {gallery.map((item, i) => (
            <figure
              key={item.src}
              className="overflow-hidden rounded-lg border border-border bg-card shadow-sm"
            >
              <img
                src={item.src}
                alt={`${item.work} — ${item.author}`}
                loading="lazy"
                className="aspect-square w-full object-cover"
              />
              <figcaption className="flex items-start justify-between gap-3 p-3">
                <div className="min-w-0">
                  <div className="text-xs text-muted-foreground">#{i + 1}</div>
                  <div className="truncate text-sm font-medium text-foreground">
                    {item.work}
                  </div>
                  <div className="truncate text-xs text-muted-foreground">{item.author}</div>
                </div>
                <Badge variant={toneVariant(item.tone)} className="shrink-0 capitalize">
                  {item.tone}
                </Badge>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GalleryPreview;
